import produce from 'immer';
import _ from 'lodash';

import {
  ORDER_ASCENDING,
  ORDER_DESCENDING
} from '../../../utils/constants/tableConstants';
import moshiConfig from '../../../utils/moshiConfig';
import {
  setFilterToStoreDraft,
  setFiltersToStoreDraft
} from '../../../utils/redux/listUtils';

import {
  CLEAR_ESTIMATE_DETAIL,
  GET_ESTIMATE_DETAIL_FAILURE,
  GET_ESTIMATE_DETAIL_IN_PROGRESS,
  GET_ESTIMATE_DETAIL_SUCCESS,
  GET_ESTIMATE_LIST_FAILURE,
  GET_ESTIMATE_LIST_IN_PROGRESS,
  GET_ESTIMATE_LIST_SUCCESS,
  PATCH_ESTIMATE_SUCCESS,
  SET_ESTIMATE_LIST_FILTER,
  SET_ESTIMATE_LIST_FILTERS,
  SET_ESTIMATE_LIST_ORDER,
  SET_ESTIMATE_LIST_PAGINATION,
  UPDATE_ESTIMATE_SUCCESS,
  CLEAR_ESTIMATE_LIST_FILTER,
  CLEAR_ESTIMATE_LIST_FILTER_NO_POLL
} from './estimateTypes';

import { LOGOUT } from '../../auth/authReducer';

import EstimateModel from '../../../metadata/model/billing/bill/EstimateModel';

export const initialState = {
  list: [],
  loadingList: false,
  detail: null,
  loadingDetail: false,
  filter: {
    sortBy: 'issuedAt',
    order: ORDER_DESCENDING
  },
  pagination: {
    resultCount: 0,
    pageCount: 0,
    limit: _.get(moshiConfig, 'list.pagination.limit', 20),
    page: 1
  }
};

// eslint-disable-next-line default-param-last
const estimateReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, ...payload } = action;

    switch (type) {
      case GET_ESTIMATE_LIST_IN_PROGRESS:
        draft.loadingList = true;
        break;
      case GET_ESTIMATE_LIST_SUCCESS:
        const responsePayload = _.get(payload, 'response', payload);
        const billingEstimates = _.get(responsePayload, 'data', []);

        const maxResultsRaw = _.get(
          responsePayload,
          'headers.x-total-count',
          draft.pagination.limit
        );
        const maxResults = _.parseInt(maxResultsRaw);

        draft.pagination.resultCount = maxResults;
        draft.pagination.pageCount = _.ceil(
          maxResults / draft.pagination.limit
        );

        draft.loadingList = false;
        draft.list = _.sortBy(billingEstimates, 'name');
        break;
      case GET_ESTIMATE_LIST_FAILURE:
        draft.loadingList = false;
        break;
      case GET_ESTIMATE_DETAIL_IN_PROGRESS:
        draft.loadingDetail = true;
        break;
      case PATCH_ESTIMATE_SUCCESS:
      case UPDATE_ESTIMATE_SUCCESS:
      case GET_ESTIMATE_DETAIL_SUCCESS:
        const estimate = EstimateModel.fromDto(
          _.get(payload, 'response.data', {})
        );

        draft.loadingDetail = false;
        draft.detail = estimate;
        break;
      case GET_ESTIMATE_DETAIL_FAILURE:
        draft.loadingDetail = false;
        break;
      case CLEAR_ESTIMATE_DETAIL:
        draft.detail = null;
        break;
      case SET_ESTIMATE_LIST_FILTER:
        setFilterToStoreDraft(draft, payload, initialState.pagination.page);

        break;
      case SET_ESTIMATE_LIST_FILTERS:
        const filters = _.getNonEmpty(payload, 'filters', []);

        setFiltersToStoreDraft(draft, filters, initialState.pagination.page);

        break;
      case SET_ESTIMATE_LIST_ORDER:
        const sortBy = _.getNonEmpty(payload, 'sortBy', null);
        const order = _.get(payload, 'order', ORDER_ASCENDING);

        draft.filter.sortBy = sortBy;
        draft.filter.order = order;
        break;
      case SET_ESTIMATE_LIST_PAGINATION:
        const paginationName = _.getNonEmpty(payload, 'paginationName', null);
        const paginationValue = _.get(payload, 'paginationValue', '');

        if (!_.isEmpty(paginationName)) {
          draft.pagination[paginationName] = paginationValue;
        }
        break;
      case CLEAR_ESTIMATE_LIST_FILTER:
      case CLEAR_ESTIMATE_LIST_FILTER_NO_POLL:
        draft.filter = initialState.filter;
        break;
      case LOGOUT:
        return initialState;
      default:
    }
  });

export default estimateReducer;
